import Vue from 'vue'
import Router from 'vue-router'
import Main from './../components/Main.vue'
import KdsMain from './../components/KdsDisplay.vue'
import Recall from './../components/RecallDisplay.vue'
import Login from './../components/Login.vue'
import BinManager from './../components/BinManager.vue'
import InfoDisplay from './../components/InfoDisplay.vue'
import GuestFacingBoard from './../components/GuestFacingBoard.vue'


Vue.use(Router)

export default new Router({
  routes: [
    { path: '/main', meta: {title: 'KDS - Main'}, component: Main },
    { path: '/kdsPrep', meta: {title: 'KDS - Preparing'}, component: KdsMain, props: {readyOrdersDisplay: false}  },
    { path: '/kdsReady', meta: {title: 'KDS - Ready for Pickup'}, component: KdsMain, props: {readyOrdersDisplay: true}  },
    { path: '/recall', meta: {title: 'KDS - Recall'}, component: Recall },
    { path: '/login', meta: {title: 'KDS - Login'}, component: Login },
    { path: '/kdsBin', meta: {title: 'KDS - Bin Manager'}, component: BinManager },
    { path: '/info', meta: {title: 'KDS - Info'}, component: InfoDisplay },
    { path: '/gfb', meta: {title: 'Guest Facing Board'}, component: GuestFacingBoard },
    { path: '/gfb/:storeID', meta: {title: 'Guest Facing Board'}, component: GuestFacingBoard },
    { path: '*', redirect: '/main'}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js